angular.module('mercury.modules.time.roster')
  .factory('Rosters', ["$http", "$q", "$resource", "settings", "userinfo", function ($http, $q, $resource, settings, userinfo) {
    var baseRosterUrl = settings.mercHost + '/time/rosters';
    var baseRosteredShiftUrl = settings.mercHost + '/time/rostered-shifts';
    var rosters = $resource(baseRosterUrl + '/:id', { id: '@id' });
    var copyRosterTemplates = $resource(baseRosterUrl + '/templates/copy');
    var rosterShifts = $resource(baseRosteredShiftUrl);
    var reassignShiftsEndpoint = $resource(baseRosteredShiftUrl + '/reassign-shifts');
    var reassignTemplateShiftsEndpoint = $resource(baseRosteredShiftUrl + '/templates/:id/reassign-shifts');

    /**
   * [setPublicToken description]
   *
   * @memberof TimeRosteredShifts
   * @param {?} token [description]
   */
    function setPublicToken(token) {
      var promise = $resource(baseRosterUrl + '/token').save({ token: token }, {}).$promise;

      promise.then(function () {
        userinfo.companyPreferenceSet({ key: 'time.rosterPublicToken', value: token });
      });

      return promise;
    }

    function getByDate(searchDate) {
      return rosters.get({ searchDate: moment(searchDate).format() }).$promise;
    }

    function getById(rosterId, inferRatesForRosteredShifts) {
      let params = { id: rosterId };

      if (typeof inferRatesForRosteredShifts !== 'undefined') {
        params.inferRatesForRosteredShifts = inferRatesForRosteredShifts;
      }

      return rosters.get(params).$promise;
    }

    function createShift(shift) {
      var shiftToSend = angular.copy(shift);
      delete shiftToSend.id;
      return rosterShifts.save(shiftToSend).$promise;
    }

    /**
     * Reassign shifts that start at or after the from time and before the to
     * time which belong to staffMemberIdFrom to staffMemberIdTo.
     * @param {*} from 
     * @param {*} to 
     * @param {*} staffMemberIdFrom 
     * @param {*} staffMemberIdTo 
     */
    function reassignShifts(
      from,
      to,
      staffMemberIdFrom,
      staffMemberIdTo
    ) {
      return reassignShiftsEndpoint
        .save({
          from: moment(from).mUtcFormat(),
          to: moment(to).mUtcFormat(),
          staffMemberIdFrom: staffMemberIdFrom,
          staffMemberIdTo: staffMemberIdTo,
        }, {})
        .$promise;
    }

    /**
     * Reassign template shifts that start at or after the from time and
     * before the to time which belong to staffMemberIdFrom to staffMemberIdTo.
     * @param {*} templateId
     * @param {*} staffMemberIdFrom 
     * @param {*} staffMemberIdTo 
     */
    function reassignTemplateShifts(
      templateId,
      staffMemberIdFrom,
      staffMemberIdTo
    ) {
      return reassignTemplateShiftsEndpoint
        .save({
          id: templateId,
          staffMemberIdFrom: staffMemberIdFrom,
          staffMemberIdTo: staffMemberIdTo,
        }, {})
        .$promise;
    }

    /**
     * Update a roster object via a PUT request.
     */
    function updateRoster(roster) {
      return rosters
        .update({
          id: roster.id,
          startDateTime: roster.startDateTime,
          endDateTime: roster.endDateTime,
          datestampDeleted: roster.datestampDeleted,
          datestampPublished: roster.datestampPublished,
          datestampLocked: roster.datestampLocked,
          templateName: roster.templateName,
        })
        .$promise;
    }

    function unlockRoster(roster) {
      // modify the locked time and perform a PUT, note we need to supply all
      // properties in this request, the backend doesn't support a PATCH
      roster.datestampLocked = null;
      return updateRoster(roster)
    }

    function saveRosterAsTemplate(sourceWeekStart, templateName) {
      const rosterToUpdate = {
        startDateTime: moment(sourceWeekStart).mUtcFormat(),
        templateName: templateName,
      };

      return copyRosterTemplates.save(rosterToUpdate).$promise;
    }

    function deactivateTemplate(templateId, templateName) {
      const rosterTemplateToUpdate = {
        id: templateId,
        templateName: templateName,
        datestampDeleted: moment().mUtcFormat()
      };
      return rosters.update(rosterTemplateToUpdate).$promise;
    }

    function restoreTemplate(templateId, templateName) {
      const rosterTemplateToUpdate = {
        id: templateId,
        templateName: templateName,
        datestampDeleted: null
      };
      return rosters.update(rosterTemplateToUpdate).$promise;
    }

    return {
      getByDate: getByDate,
      getById: getById,
      createShift: createShift,
      reassignShifts: reassignShifts,
      reassignTemplateShifts: reassignTemplateShifts,
      unlockRoster: unlockRoster,
      updateRoster: updateRoster,
      saveRosterAsTemplate: saveRosterAsTemplate,
      deactivateTemplate: deactivateTemplate,
      restoreTemplate: restoreTemplate,
      setPublicToken: setPublicToken
    };
  }]);
